<template>
  <div v-if="visible" class="soc-smart-guide-float">
    <div class="float-body">
      <div class="float-title">智能引导 · {{ stepTitle }}</div>
      <div class="float-hint">{{ instruction }}</div>
      <div class="float-actions">
        <el-button type="primary" size="mini" @click="goPage">去此页</el-button>
        <el-button size="mini" :loading="loading" @click="check">检查完成</el-button>
        <el-button size="mini" type="text" @click="openAssistant">助手</el-button>
      </div>
      <p v-if="reason" class="float-reason" :class="{ ok: passed }">{{ reason }}</p>
    </div>
  </div>
</template>

<script>
import {
  fetchActiveSmartGuideSession,
  refreshSmartGuideSession
} from '@/api/socSmartGuide'
import { leoOperatorAssistantBus, routeShowsOperatorAssistant } from '@/utils/leoOperatorAssistant'
import { getToken } from '@/utils/auth'

export default {
  name: 'SocSmartGuideFloat',
  data () {
    return {
      visible: false,
      loading: false,
      sessionId: null,
      stepTitle: '',
      instruction: '',
      routePath: '',
      boundMachineCode: '',
      reason: '',
      passed: false,
      timer: null
    }
  },
  mounted () {
    this.tick()
    this.timer = setInterval(this.tick, 10000)
    leoOperatorAssistantBus.$on('smart-guide-changed', this.tick)
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
    leoOperatorAssistantBus.$off('smart-guide-changed', this.tick)
  },
  methods: {
    async tick () {
      if (!getToken() || !routeShowsOperatorAssistant(this.$route)) {
        this.visible = false
        return
      }
      try {
        const res = await fetchActiveSmartGuideSession()
        const data = res && res.data
        if (!data || !data.active || data.status === 'COMPLETED') {
          this.visible = false
          this.sessionId = null
          return
        }
        this.visible = true
        this.sessionId = data.sessionId
        const cur = data.currentStep || {}
        this.stepTitle = cur.titleZh || ''
        this.instruction = cur.instructionZh || ''
        this.routePath = cur.routePath || ''
        this.boundMachineCode = data.boundMachineCode
          || (data.context && data.context.imie)
          || ''
        this.reason = cur.verifyReasonZh || ''
        this.passed = !!cur.verifyPassed
      } catch (e) {
        // keep last
      }
    },
    goPage () {
      if (!this.routePath) return
      const query = {}
      if (this.routePath.indexOf('simulator-xt90') >= 0 && this.boundMachineCode) {
        query.machineCode = this.boundMachineCode
      }
      if (this.$route.path !== this.routePath || (query.machineCode && this.$route.query.machineCode !== query.machineCode)) {
        this.$router.push({ path: this.routePath, query: query })
      }
    },
    openAssistant () {
      leoOperatorAssistantBus.$emit('open-smart-guide')
    },
    async check () {
      if (!this.sessionId) return
      this.loading = true
      try {
        const res = await refreshSmartGuideSession(this.sessionId)
        const data = res && res.data
        this.reason = (data && data.verifyReasonZh) || ''
        this.passed = !!(data && data.verifyPassed)
        leoOperatorAssistantBus.$emit('smart-guide-changed')
        if (data && data.advanced) {
          this.$message.success('本步已完成，进入下一步')
          const cur = data.currentStep || {}
          if (cur.routePath) {
            const q = {}
            const sn = (data && data.boundMachineCode)
              || (data && data.context && data.context.imie)
              || this.boundMachineCode
            if (cur.routePath.indexOf('simulator-xt90') >= 0 && sn) q.machineCode = sn
            this.$router.push({ path: cur.routePath, query: q })
          }
        } else if (data && data.completedNow) {
          this.$message.success('引导全部完成')
          this.visible = false
        } else if (data && data.verifyPassed === false) {
          this.$message.warning(this.reason || '尚未完成')
        }
        await this.tick()
      } catch (e) {
        this.$message.error((e && e.message) || '检查失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.soc-smart-guide-float {
  position: fixed;
  right: 24px;
  bottom: 88px;
  z-index: 3000;
  width: 280px;
  background: #fff;
  border: 1px solid #d6e4ff;
  box-shadow: 0 6px 18px rgba(64, 158, 255, 0.18);
  border-radius: 10px;
  padding: 12px;
}
.float-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}
.float-hint {
  font-size: 12px;
  color: #606266;
  line-height: 1.45;
  margin-bottom: 8px;
}
.float-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.float-reason {
  margin: 8px 0 0;
  font-size: 12px;
  color: #e6a23c;
}
.float-reason.ok {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/components/LeoKnowledge/SocSmartGuideFloat.vue